<template>
  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <Checkbox
        :model-value="setExpiration"
        :binary="true"
        @update:model-value="$emit('update:setExpiration', $event)"
      />
      <label class="text-sm text-gray-700">{{ $t('users.create_user.title_validity') }}</label>

    </div>
    <DatePicker
      :readonly="!setExpiration"
      :enable-time-picker="false"
      :model-value="validityRange"
      :min-date="new Date()"
      prevent-min-max-navigation
      format="yyyy-MM-dd"
      :placeholder="$t('users.create_user.start_date_placeholder')"
      text-input
      required
      range
      class="w-full"
      @update:model-value="$emit('update:validityRange', $event)"
    />
  </div>
</template>

<script>
import { Checkbox } from 'primevue';

export default {
  name: 'AdditionalSettingsSection',
  components: {
    Checkbox,
  },
  props: {
    setExpiration: {
      type: Boolean,
      required: true,
    },
    validityRange: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:setExpiration', 'update:validityRange'],
};
</script> 